import React, { useEffect, useState } from "react";
import NavBar from "../../../Component/NavBar/NavBar";
import { IoIosAddCircleOutline } from "react-icons/io";
import apiRequests from "../../../Component/axios/config/config";
import Loading from "../../../Component/Loading/Loading";
import { Link, useNavigate } from "react-router-dom";
import noImage from "../../../font & image/image/noImages.png";
import toast from "react-hot-toast";

export default function Grocery() {
  const [products, setProducts] = useState([]);
  const [productID, setProductID] = useState("");
  const [name, setName] = useState("");
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusProduct, setStatusProduct] = useState(null);

  const [loading, setLoading] = useState(true);
  const [updateProduct, setUpdateProduct] = useState(false);

  const [showModalDelete, setShowModalDelete] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();

  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchProducts(currentPage, search);
  }, [currentPage, updateProduct]);

  const fetchProducts = (page, searchValue = search) => {
    setLoading(true);
    apiRequests
      .get(`/api/product/get-all-admin`, {
        params: {
          page: page,
          limit: 20,
          distributor: "seller",
          search: searchValue,
        },
      })
      .then((response) => {
        console.log(response.data.data.docs);
        setProducts(response.data.data.docs);
        setTotalPages(response.data.data.totalPages);
      })
      .catch(() => {
        console.error("Failed to fetch products");
      })
      .finally(() => setLoading(false));
  };

  const handleDelete = (id, name) => {
    setShowModalDelete(true);
    setName(name);
    setProductID(id);
  };

  const handleEdit = (id) => {
    navigate(`/product/${"Grocery"}/${id}`);
  };

  const handleAdd = () => {
    navigate("/product/create");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1);
    fetchProducts(1, value);
  };

  const handleStatus = (id, name, currentStatus) => {
    setStatusProduct({
      id,
      name,
      currentStatus,
    });

    setShowStatusModal(true);
  };

  return (
    <div className="p-6">
      <div className="text-3xl font-bold text-gray-800 mb-6">
        Grocery Products
      </div>

      <NavBar onSearch={handleSearch} />

      <div className="flex justify-center mt-8">
        <div className="w-full max-w-6xl md:overflow-x-auto">
          <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
            <thead className="bg-gradient-to-r from-green-400 to-blue-500 text-white">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Image
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  seller
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  status
                </th>
                <th className="px-6 py-3 text-center text-sm font-medium">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan="5" className="px-6 py-4 text-center">
                    <Loading />
                  </td>
                </tr>
              ) : products.length > 0 ? (
                products.map((product) => {
                  return (
                    <tr
                      key={product._id}
                      className="hover:bg-gray-100 transition duration-200"
                    >
                      <td className="px-6 py-4">
                        <img
                          src={
                            product.images
                              ? `${product.images[0]?.path}`
                              : noImage
                          }
                          alt={product.name}
                          className="w-16 h-16 object-cover rounded-lg"
                        />
                      </td>
                      <td className="px-6 py-4 text-gray-800 font-medium">
                        <Link to={`/product/Grocery/${product._id}`}>
                          {" "}
                          {product.name}
                        </Link>
                      </td>
                      <td className="px-6 py-4 text-gray-800 font-medium">
                        <Link to={`/seller/${product.seller._id}`}>
                          {" "}
                          {product.seller.userName}
                        </Link>
                      </td>
                      <td className="px-6 py-4 text-gray-600">
                        {product.category?.name}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() =>
                            handleStatus(
                              product._id,
                              product.name,
                              product.is_active,
                            )
                          }
                          className={`px-3 py-1 rounded-full text-sm font-medium ${
                            product.is_active
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          }`}
                        >
                          {product.is_active ? "Active" : "Inactive"}
                        </button>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <button
                          className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                          onClick={() => handleEdit(product._id)}
                        >
                          Edit
                        </button>
                        <button
                          className="text-red-500 hover:text-red-700 font-medium"
                          onClick={() =>
                            handleDelete(product._id, product.name)
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    className="px-6 py-4 text-center text-gray-500"
                  >
                    No products found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="flex justify-between items-center mt-4">
            <button
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="text-gray-700">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      {showModalDelete && (
        <ModalDelete
          setShow={setShowModalDelete}
          setUpdateProduct={setUpdateProduct}
          updateProduct={updateProduct}
          name={name}
          id={productID}
        />
      )}
      {showStatusModal && statusProduct && (
        <ModalStatus
          setShow={setShowStatusModal}
          setUpdateProduct={setUpdateProduct}
          updateProduct={updateProduct}
          id={statusProduct.id}
          name={statusProduct.name}
          currentStatus={statusProduct.currentStatus}
        />
      )}
    </div>
  );
}

export function ModalDelete({
  setShow,
  id,
  name,
  setUpdateProduct,
  updateProduct,
}) {
  const [loading, setLoading] = useState(false);

  function DeleteProduct() {
    setLoading(true);
    apiRequests
      .delete(`/api/product/delete-admin`, {
        data: {
          id: id,
        },
      })
      .then((response) => {
        toast.success("successfully Remove product!");
        setUpdateProduct(!updateProduct);
        setShow(false);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }

  return (
    <div className="report-modal fixed inset-0 bg-black bg-opacity-60 transition-opacity">
      <div className="flex min-h-full items-end justify-center p-3 text-center">
        <div className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[30%] md:w-[90%] m-auto flex flex-col gap-5">
          <div className="text-gray-500">
            Do You Want Delete This Product
            <span className="text-firstColor-shade9 font-bold"> {name} </span>?
          </div>

          <div className="flex justify-center items-center gap-5 ">
            <button
              className="px-4 py-1 border-2 hover:bg-red-600 hover:text-white rounded-lg border-red-600 text-red-600"
              onClick={DeleteProduct}
            >
              {loading ? <Loading /> : "Delete"}
            </button>

            <button
              className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export function ModalStatus({
  setShow,
  id,
  name,
  currentStatus,
  setUpdateProduct,
  updateProduct,
}) {
  const [loading, setLoading] = useState(false);

  const handleStatusChange = () => {
    setLoading(true);

    apiRequests
      .patch(`/api/product/active-product-admin/${id}`)
      .then(() => {
        toast.success(
          currentStatus
            ? "Product rejected successfully!"
            : "Product approved successfully!",
        );

        setUpdateProduct(!updateProduct);
        setShow(false);
      })
      .catch(() => {
        toast.error("Failed to change product status");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60">
      <div className="flex min-h-full items-center justify-center p-3">
        <div className="w-[30%] md:w-[90%] bg-white rounded-lg p-8 flex flex-col gap-6">
          <div className="text-gray-600 text-center">
            <p>
              Do you want to{" "}
              <span className="font-bold text-gray-800">
                {currentStatus ? "reject" : "approve"}
              </span>{" "}
              this product?
            </p>

            <p className="mt-2 font-semibold text-firstColor-shade9">{name}</p>
          </div>

          <div className="flex justify-center gap-5">
            <button
              onClick={handleStatusChange}
              disabled={loading}
              className={`px-5 py-2 rounded-lg text-white ${
                currentStatus
                  ? "bg-red-700 hover:bg-red-800"
                  : "bg-green-700 hover:bg-green-800"
              }`}
            >
              {loading ? <Loading /> : currentStatus ? "Reject" : "Approve"}
            </button>

            <button
              onClick={() => setShow(false)}
              disabled={loading}
              className="px-5 py-2 border rounded-lg hover:bg-gray-100"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
